import * as ActionType from '../../core/ActionType';
import * as Constants from '../../utils/constants';
import { ApiCallBeginAction } from '../api/Action';
import { setErrorResponse, setSuccessResponse } from '../responses/Action';
import { MotoristaService } from './Service';


/**
 * 
 * @param {Objeto completo contendo a lista de motorista} motoristaObject 
 */
export const getMotoristasResponse = motoristaObject => ({
    type: ActionType.GET_MOTORISTAS_RESPONSE,
    motoristaObject
});

export const addMotoristaResponse = motoristaObject => ({
    type: ActionType.ADD_MOTORISTA_RESPONSE,
    motoristaObject
});


export function desativarOrAtivarMotoristaByIdAction(id,ativar) {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));        
        try {
            await MotoristaService.desativarOrAtivarMotorista(id,ativar)
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

/**
 * Método responsável por buscar todos os motoristas da API
 */
export function getMotoristasAction(todos) {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());

        try {
            let motoristaObject = await MotoristaService.getMotoristas(todos)
            dispatch(getMotoristasResponse(motoristaObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

export function getMotoristaByIdAction(id) {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());
        try {
            let motoristaObject = await MotoristaService.getMotoristaById(id)
            dispatch(getMotoristasResponse(motoristaObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}

export function saveMotoristaAction(motorista) {
    return async function (dispatch) {
        await dispatch(setSuccessResponse(null));
        await dispatch(setErrorResponse(null));
        await dispatch(ApiCallBeginAction());
        try {
            let motoristaObject;

            if (motorista.id) motoristaObject = await MotoristaService.putMotorista(motorista);
            else motoristaObject = await MotoristaService.postMotorista(motorista);
            await dispatch(setSuccessResponse(Constants.DESCRICAO_SUCCESS));
            await dispatch(addMotoristaResponse(motoristaObject));
            return motoristaObject;
        } catch (error) {
            dispatch(setErrorResponse(error));
            throw error;
        }


    }
}
